import { LogClient_MemBuffer } from '@nu-art/ts-common';
/** Number of rolling buffers to retain (current + previous). */
const MaxBuffers = 2;
/** Max size of each buffer in bytes before it rotates (0.5 MB). */
const MaxBufferSize = 0.5 * 1024 * 1024;
/**
 * In-memory rolling log buffer for the advisor app.
 *
 * Keeps {@link MaxBuffers} buffers of {@link MaxBufferSize} each, giving us a continuous
 * window of the most recent logs (between 0.5MB and 1MB). Attached to bug reports so we
 * always ship the logs leading up to the reported issue.
 *
 * Colors are disabled so the buffered logs are plain text (no ANSI escape codes) - the
 * logs are read from bug reports, not a terminal.
 */
export const LogClient_AdvisorMemBuffer = new LogClient_MemBuffer('advisor', MaxBuffers, MaxBufferSize)
    .disableColors();
/**
 * Returns the retained logs across all rolling buffers, oldest entries first.
 *
 * `buffers[0]` is the current (newest) buffer and higher indices hold older, rotated
 * buffers - so we reverse to produce a chronological, human-readable log dump.
 */
export const getAdvisorLogs = () => LogClient_AdvisorMemBuffer.buffers.slice().reverse().join('');
//# sourceMappingURL=LogClient_AdvisorMemBuffer.js.map